import type { ApiResponse, InstructionPayload } from '@/store/types'
import { post } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import { decodeInstruction, type Instruction } from '@/backend/schema/instruction'

/**
 * Creates AI assisted review instruction on backend
 */
export const createInstruction = async (params: {
  team_slug: string
  title: string
  content: string
  multi_modal: boolean
}): Promise<ApiResponse<Instruction> | ParsedError> => {
  const { team_slug, ...rest } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions`

  try {
    const response = await post<InstructionPayload>(path, rest)

    return {
      data: decodeInstruction(response.data),
    }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_CREATE)
  }
}
